import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductsHero from '../components/ProductsHero';
import ProductsList from '../components/ProductsList';
import './ProductsPage.css';

const ProductsPage = () => {
    // Scroll to top on mount so navbar click always starts at the hero section
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="products-page">
            <Navbar />

            <main className="products-page-content">
                <ProductsHero />
                <ProductsList />
            </main>

            <Footer />
        </div>
    );
};

export default ProductsPage;
